module.exports = __webpack_public_path__ + "static/media/bucks--big.757a12f5.png";